'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListForm = require('./components/ListForm.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-form/index.js
// module id = 1308
// module chunks = 0